<template>
    <UserModalShell title="Account actions" test-id="user-account-actions-modal" @cancel="$emit('cancel')">
        <UserActions :user="user" @cancel="$emit('cancel')" @update="$emit('update')" />
    </UserModalShell>
</template>

<script setup lang="ts">
import type { User } from '@/stores/store-interfaces';
import UserActions from '@/components/manager/user-modal/user-actions.vue';
import UserModalShell from '@/components/manager/user-modal/user-modal-shell.vue';

defineProps<{
    user: User;
}>();

defineEmits(['cancel', 'update']);
</script>
